import Component from '../core/Component'
import keycode from 'keycode'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'
import support from '../utils/BrowserSupport'
import Scroll, {disableScroll,enableScroll} from '../services/Scroll'
import enquire from 'enquire.js'
import {queries} from '../core/config'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
    LANG_ONLY: 'is-lang-only'
}

export default class PopupNav extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            inner: null
        }

        this.mode = null
        this.timerScroll = null
        this.enquireHandler = {
            match: () => {
                this.isMobile = true
            },
            unmatch: () => {
                this.isMobile = false
            }
        }
    }

    prepare() {
        enquire.register(queries.smallWideMax, this.enquireHandler)
        EventBus.on(EVENTS.SWUP_CLICK_LINK, this.handleSwupClick)

        this.element.addEventListener(support.transitionEnd, event => {
            if (this.ref.inner === event.target && !this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })
    }

    destroy() {
        this.close()
        enquire.unregister(queries.smallWideMax, this.enquireHandler)
        document.removeEventListener('keydown', this.handleKeydown)
        EventBus.off(EVENTS.SWUP_CLICK_LINK, this.handleSwupClick)
    }

    handleSwupClick = () => {
        this.close()
    }

    handleClick(event) {
        if (!this.ref.content.contains(event.target)) {
            event.preventDefault()
            this.close()
        } else if (event.target.closest('a')) {
            this.close()
        }
    }

    handleKeydown = event => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    handleScroll = () => {
        this.close()
        Scroll.off('scroll', this.handleScroll)
    }

    setMode(mode) {
        this.mode = mode
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }

        clearTimeout(this.timerScroll)

        setTimeout(() => {
            this.element.classList.remove(STATES.LANG_ONLY)
        }, 500);

        document.documentElement.classList.remove('is-nav-open')

        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeydown)
        if (this.isMobile) {
            enableScroll()
        }
    }

    open() {
        if (this.mode === 'lang-only') {
            this.element.classList.add(STATES.LANG_ONLY)
        }

        document.documentElement.classList.add('is-nav-open')

        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        document.addEventListener('keydown', this.handleKeydown)

        if (this.isMobile) {
            Scroll.disableScroll()
        } else {
            this.timerScroll = setTimeout(() => {
                Scroll.on('scroll', this.handleScroll)
            }, 1200)
        }
    }
}